"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var tryActionCatchError = function tryActionCatchError(_ref, operations) {
  var succeeded = _ref.succeeded,
      failed = _ref.failed;
  return (0, _operators.mergeMap)(function (action) {
    var _of;

    return (_of = (0, _rxjs.of)(action)).pipe.apply(_of, _toConsumableArray(operations).concat([(0, _operators.map)(succeeded), (0, _operators.catchError)(function (_ref2) {
      var code = _ref2.code,
          message = _ref2.message;
      return (0, _rxjs.of)(failed({
        code: code,
        message: message
      }));
    })]));
  });
}; // const tryOperationsCatchError = failureHandler => (...operations) =>
//   mergeMap(value =>
//     of(value).pipe(
//       ...operations,
//       catchError(error => of(failureHandler(error, value))),
//     ),
//   );


var _default = tryActionCatchError;
exports["default"] = _default;